import Signup from "./components/Signup";
import SignupUpdateUser from "./components/SignupUpdateUser";
import ValidatePassword from "./components/ValidatePassword";
import userMenuToggle from "./components/UserMenuToggle";
import MarketoStatus  from "./components/MarketoStatus";

window.addEventListener( 'DOMContentLoaded', () => {
  new Signup();
  new SignupUpdateUser( 'td-signup-form-update-marketo-user', 'signup_update_marketo_user' );
  new SignupUpdateUser( 'td-resend-email-form', 'signup_resend_email' );
  new ValidatePassword( 'td-password-form', 'signup_update_password', window.signup_variables );
  new MarketoStatus( '.signup-content', '.td-form' );
  userMenuToggle();
} );
